
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers/screens",
      function () {
        return require("private-next-pages/rollers/screens/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers/screens"])
      });
    }
  